import React, { useState, useEffect } from "react";
import { formatNumber } from "utils/currencyFormat";
import "react-dropdown/style.css";
import BaoCaoTongQuanApi from "../../../service/TongChiNhanh/BaoCaoTongQuanApi";
export const DsCuaHang = ({ }) => {
    useEffect(() => {
        DanhSachCuaHang();
    }, []);

    const [danhsachcuahang, setDanhSachCuaHang] = useState();
    const DanhSachCuaHang = () => {
        BaoCaoTongQuanApi.DanhSachCuaHang().then((response) => {
            setDanhSachCuaHang(response.data)
        });
    };

    const OpenLink = (macuahang) => () => {
        let url = "/tong-chi-nhanh/thong-ke-cua-hang.aspx?macuahang=" + macuahang;
        window.open(url, "_blank", "noreferrer");
    }

    return (
        <>
            <div className="row" style={{ marginTop: "5px", marginBottom: "10px" }}>
                <div className="col-md-12">
                    <div className="row" style={{ paddingRight: "15px", paddingLeft: "15px" }} >
                        {danhsachcuahang && danhsachcuahang.length >= 3 ? (
                            //Nếu có từ 3 cửa hàng
                            <>
                                {danhsachcuahang.map((item, index) => (
                                    <>
                                        <div className="col-md-4" style={index > 0 && (index + 1) % 3 == 0 ? {} : { paddingRight: "0px" }} onClick={OpenLink(item.MaCuaHang)}>
                                            <div style={(index + 1) > 3 ? { paddingTop: "15px" } : {}}>
                                                <div className="divbaocaochinhanh-cuahang itemChiNhanh">
                                                    <div className="row ">
                                                        <div className="col-md-12 ">
                                                            <div style={{ padding: "15px 15px 0px 15px" }}>
                                                                <div className="row">
                                                                    <span className="title-cuahang-ico1" style={{ float: "left", marginLeft: "15px" }}></span>
                                                                    <span className="title" style={{ float: "left", marginLeft: "10px", marginTop: "0" }}>{item.TenCuaHang}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div style={{ padding: "0px 15px 15px 15px" }}>
                                                                <div className="row">
                                                                    <div className="col-md-12">
                                                                        <div className="title2" >Tổng số hợp đồng đang vay</div>
                                                                        <div className="title" style={{ marginTop: "0px" }}>{formatNumber(item.SoHopDongDangVay)}</div>
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                        <div className="title2" >Số tiền đang vay</div>
                                                                        <div className="title" style={{ marginTop: "0px" }}>{formatNumber(item.SoTienDangVay)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div >
                                    </>
                                ))}
                            </>
                        ) : (
                            <>
                                {danhsachcuahang && danhsachcuahang.length == 2 && (
                                    <>
                                        {danhsachcuahang.map((item, index) => (
                                            <>
                                                <div className="col-md-6" style={(index + 1) == 2 ? {} : { paddingRight: "0px" }} onClick={OpenLink(item.MaCuaHang)}>
                                                    <div className="divbaocaochinhanh-cuahang itemChiNhanh">
                                                        <div className="row ">
                                                            <div className="col-md-12 ">
                                                                <div style={{ padding: "15px 15px 0px 15px" }}>
                                                                    <div className="row">
                                                                        <span className="title-cuahang-ico1" style={{ float: "left", marginLeft: "15px" }}></span>
                                                                        <span className="title" style={{ float: "left", marginLeft: "10px", marginTop: "0" }}>{item.TenCuaHang}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div style={{ padding: "0px 15px 15px 15px" }}>
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            <div className="title2" >Tổng số hợp đồng đang vay</div>
                                                                            <div className="title" style={{ marginTop: "0px" }}>{formatNumber(item.SoHopDongDangVay)}</div>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="title2" >Số tiền đang vay</div>
                                                                            <div className="title" style={{ marginTop: "0px" }}>{formatNumber(item.SoTienDangVay)}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </>
                                )}
                                {danhsachcuahang && danhsachcuahang.length == 1 && (
                                    <>
                                        {danhsachcuahang.map((item, index) => (
                                            <>
                                                <div className="col-md-12" style={{ paddingRight: "0px" }} onClick={OpenLink(item.MaCuaHang)}>
                                                    <div className="divbaocaochinhanh-cuahang itemChiNhanh">
                                                        <div className="row ">
                                                            <div className="col-md-12 ">
                                                                <div style={{ padding: "15px 15px 0px 15px" }}>
                                                                    <div className="row">
                                                                        <span className="title-cuahang-ico1" style={{ float: "left", marginLeft: "15px" }}></span>
                                                                        <span className="title" style={{ float: "left", marginLeft: "10px", marginTop: "0" }}>{item.TenCuaHang}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                                <div style={{ padding: "0px 15px 15px 15px" }}>
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            <div className="title2" >Tổng số hợp đồng đang vay</div>
                                                                            <div className="title" style={{ marginTop: "0px" }}>{formatNumber(item.SoHopDongDangVay)}</div>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="title2" >Số tiền đang vay</div>
                                                                            <div className="title" style={{ marginTop: "0px" }}>{formatNumber(item.SoTienDangVay)}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))}
                                    </>
                                )}

                            </>
                        )}




                        {/* <div className="col-md-4" style={{ paddingRight: "0px" }}>
                            <div className="divbaocaochinhanh-cuahang itemChiNhanh">
                                <div className="row ">
                                    <div className="col-md-12 ">
                                        <div style={{ padding: "15px 15px 0px 15px" }}>
                                            <div className="row">
                                                <span className="title-cuahang-ico1" style={{ float: "left", marginLeft: "15px" }}></span>
                                                <span className="title" style={{ float: "left", marginLeft: "10px", marginTop: "0" }}>Tên cửa hàng hơi bị dài cần xem thêm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div style={{ padding: "0px 15px 15px 15px" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="title2" >Tổng số hợp đồng đang vay</div>
                                                    <div className="title" style={{ marginTop: "0px" }}>999</div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="title2" >Số tiền đang vay</div>
                                                    <div className="title" style={{ marginTop: "0px" }}>99999999999999</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 " style={{ paddingRight: "0px" }}>
                            <div className="divbaocaochinhanh-cuahang itemChiNhanh">
                                <div className="row">
                                    <div className="col-md-12 ">
                                        <div style={{ padding: "15px 15px 0px 15px" }}>
                                            <div className="row">
                                                <span className="title-cuahang-ico1" style={{ float: "left", marginLeft: "15px" }}></span>
                                                <span className="title" style={{ float: "left", marginLeft: "10px", marginTop: "0" }}>Tên cửa hàng hơi bị dài cần xem thêm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div style={{ padding: "0px 15px 15px 15px" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="title2" >Tổng số hợp đồng đang vay</div>
                                                    <div className="title" style={{ marginTop: "0px" }}>999</div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="title2" >Số tiền đang vay</div>
                                                    <div className="title" style={{ marginTop: "0px" }}>99999999999999</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 " >
                            <div className="divbaocaochinhanh-cuahang itemChiNhanh">
                                <div className="row">
                                    <div className="col-md-12 ">
                                        <div style={{ padding: "15px 15px 0px 15px" }}>
                                            <div className="row">
                                                <span className="title-cuahang-ico1" style={{ float: "left", marginLeft: "15px" }}></span>
                                                <span className="title" style={{ float: "left", marginLeft: "10px", marginTop: "0" }}>Tên cửa hàng hơi bị dài cần xem thêm</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div style={{ padding: "0px 15px 15px 15px" }}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="title2" >Tổng số hợp đồng đang vay</div>
                                                    <div className="title" style={{ marginTop: "0px" }}>999</div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="title2" >Số tiền đang vay</div>
                                                    <div className="title" style={{ marginTop: "0px" }}>99999999999999</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>

            </div >
        </>
    );
};
